<script setup lang="ts">
const flags = useFeatureFlags()
const links = useLinks()
const { isMobile } = useDevice()
const logo = useThemeLogo('menu')
</script>

<template>
    <nav class="navbar">
        <SelfAssessmentContainer v-if="flags?.enableSelfAssessment" />

        <div class="navbar__content">
            <NuxtImg
                v-if="logo?.src"
                class="navbar__logo"
                provider="cloudflare"
                preset="local"
                :src="logo.src"
                :modifiers="{ dpr: 2 }"
                :height="isMobile ? '40px' : '60px'"
                alt="Lux Casino logo"
            />

            <div class="navbar__actions">
                <UIButton
                    v-bind="links.login.props()"
                    class="navbar__login-btn"
                    as="link"
                    size="sm"
                    data-test="nav-bar-button-login"
                >
                    <span class="bold">Log in</span>
                </UIButton>

                <NuxtLink
                    to="/?auth=signup"
                    class="navbar__join-btn"
                    data-test="nav-bar-button-signup"
                >
                    Join
                </NuxtLink>
            </div>
        </div>
    </nav>
</template>

<style scoped lang="scss">
.navbar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 10;
    background: var(--nav-background, linear-gradient(to bottom, #182138 0%, #182138 60px, transparent 100%));

    &__content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #fff;
        max-width: 1024px;
        width: 100%;
        margin: auto;
        padding: 14px 16px;

        @media (min-width: 1367px) {
            max-width: 1366px;
        }
    }

    &__logo {
        display: block;
    }

    &__actions {
        display: flex;
        align-items: center;
        gap: 16px;
    }

    &__login-btn {
        color: var(--login-button-color, #fff);
        // Override UIButton sm box-model so this link-style button
        // has no extra height — lets flex align-items: center land on
        // the same visual center as the JOIN NOW button.
        min-height: unset !important;
        padding: 0 !important;
        display: inline-flex !important;
        align-items: center;

        :deep(.btn__container) {
            min-height: unset;
            padding: 0;
        }
    }

    &__join-btn {
        display: inline-flex;
        align-items: center;
        background: linear-gradient(135deg, #f5d040, #f0bc00, #c99e00);
        color: #0d1a0f;
        border: none;
        border-bottom: 2px solid #c99e00;
        border-radius: 0;
        padding: 8px 22px;
        font-family: 'Jost', sans-serif;
        font-weight: 900;
        font-size: 13px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        white-space: nowrap;
        text-decoration: none;
        transition:
            background 0.2s ease,
            box-shadow 0.2s ease;
        line-height: 1;

        &:hover {
            background: linear-gradient(135deg, #fde048, #f5d040, #d4a800);
            box-shadow: 0 4px 16px rgba(240, 188, 0, 0.35);
        }

        @media (max-width: 767px) {
            padding: 7px 14px;
            font-size: 11px;
        }
    }
}
</style>
